import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useMatch } from 'react-router-dom'

import Button from 'js/components/Button/Button'
import DropdownButton from 'js/components/DropdownButton/DropdownButton'
import useSubtypes from 'js/lib/hooks/useSubtypes'

const CreateContentButton = ({ plugins, canCreateNews, url }) => {
    const { t } = useTranslation()
    const location = useLocation()

    const match = useMatch('groups/view/:groupGuid/:groupSlug/:page')
    const pageParam = match?.params?.page

    const isActiveType = (slug) => {
        // Group plugins contains slugs instead of keys
        return pageParam === slug
    }

    const canCreateType = (slug) => {
        // Group plugins contains slugs instead of keys
        if (slug === 'news' && !canCreateNews) return false
        return plugins.includes(slug)
    }

    const subtypes = useSubtypes([
        'event',
        'blog',
        'discussion',
        'question',
        'news',
        'wiki',
        'podcast',
        'task',
    ])

    const filteredSubtypes = subtypes.filter(({ slug }) => {
        return canCreateType(slug)
    })

    const createContentOptions = filteredSubtypes
        .map(({ name, slug }) => {
            return {
                default: isActiveType(slug),
                to: `${url}/${slug}/add`,
                name: name,
                state: {
                    prevPathname: location.pathname,
                },
            }
        })
        .filter(Boolean)

    const currentPageKey = filteredSubtypes.find(
        ({ slug }) => slug === pageParam,
    )?.key
    const createContentLabel = currentPageKey
        ? t(`entity-${currentPageKey}.create`)
        : null

    return (
        <DropdownButton options={createContentOptions} showArrow>
            {createContentLabel || (
                <Button size="normal" variant="primary">
                    <span style={{ marginRight: 6 }}>{t('action.create')}</span>
                </Button>
            )}
        </DropdownButton>
    )
}

export default CreateContentButton
